// @mui
import { List, Box } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
import useAuth from '../../../hooks/useAuth';
//
import { NavSectionProps } from '../type';
import { ListSubheaderStyle } from './style';
import NavList from './NavList';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ navConfig, isCollapse, ...other }: NavSectionProps) {
  const { translate } = useLocales();
  // Role-aware section rendering: show a section header only when the current
  // user can see at least one item in it (mirrors RoleBasedGuard) — otherwise a
  // role like sales/customer-care would see empty "Learning"/"Commerce" headers.
  const { user } = useAuth();
  const userRoles: string[] = (user as any)?.roles ?? [];
  const isSuperAdmin = userRoles.includes('super-admin');
  const canSee = (roles?: string[]) =>
    typeof roles === 'undefined' || isSuperAdmin || roles.some((r) => userRoles.includes(r));

  return (
    <Box {...other}>
      {navConfig.map((group) => {
        if (!canSee((group as any).roles)) return null;
        const items = group.items.filter((item) => canSee((item as any).roles));
        if (!items.length) return null;
        return (
          <List key={group.subheader} disablePadding sx={{ px: 2 }}>
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0,
                }),
              }}
            >
              {translate(group.subheader)}
            </ListSubheaderStyle>

            {items.map((list) => (
              <NavList
                key={list.title + list.path}
                data={list}
                depth={1}
                hasChildren={!!list.children}
                isCollapse={isCollapse}
              />
            ))}
          </List>
        );
      })}
    </Box>
  );
}
